import { Link } from "react-router-dom";
import styled from "styled-components";
import Icons from "../assets/icons";

interface widthInterface {
  w?: number;
}
const navList = {
  div1: [
    { name: "footerPolicy2", to: "/policy" },
    { name: "footerSiteMap", to: "/sitemap" },
    { name: "footerPost", to: "/post" },
    // {
    //   name: "footerDownload",
    //   to: "https://scgs--demo.sandbox.my.salesforce-sites.com/inquire",
    // },
  ],
  div2: [
    {
      key: "footerAddressKey",
      value: "footerAddressValue",
    },
    { key: "footerEmailKey", value: "footerEmailValue" },
    { key: "footerTelKey", value: "footerTelValue" },
  ],
  div3: [
    {
      key: " ",
      value: "footerCopyrightValue",
    },
  ],
  sns: [
    { logo: <Icons.KakaoTalk />, to: "https://pf.kakao.com/_dqxnWs" },
    { logo: <Icons.FaceBook />, to: "https://www.facebook.com/SCGSolutions" },
    { logo: <Icons.Blog />, to: "https://blog.naver.com/scgs10986" },
    {
      logo: <Icons.Instargram />,
      to: "https://www.instagram.com/dell_with_scgs/",
    },
  ],
};
const FooterStyle = styled.ul<widthInterface>`
  background: #000000;
  color: #959aa3;
  margin-top: auto;
  font-size: 13px;
  .footer-box {
    padding: 10px 0px;
    max-width: 1200px;
    width: 95%;
    margin: auto;
    display: flex;
    .footer-left {
      width: 100%;
      .footer-contents {
        display: flex;
        li {
          p {
            position: relative;
            a {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
            }
          }
        }
        .logo-area {
          height: 30px;
          display: flex;
          a {
            height: 100%;
            aspect-ratio: 1;
            svg {
              width: 100%;
              height: auto;
            }
          }
        }
        .footer-select {
          display: flex;
          select {
            margin: auto 0;
            cursor: pointer;
            background: none;
            color: #959aa3;
          }
        }
        &.footer-between {
          justify-content: space-between;
          ul {
            display: flex;
            & + ul {
              margin-left: 10px;
            }
          }
        }
        li + li {
          margin-left: 15px;
        }
        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
  li {
    position: relative;
  }
  a {
    transition: 0.3s;
    display: flex;
    path {
      transition: 0.3s;
    }
    &:hover {
      path {
        transition: 0.1s;
      }
      g {
        path {
          fill: #3e4149;
        }
      }
      path {
        fill: #fff;
      }
      transition: 0.1s;
      color: #fff;
    }
  }
  @media (max-width: 768px) {
    .footer-box {
      padding: 20px 5px;
      display: flex;
      .footer-left {
        .footer-contents {
          display: flex;
          flex-wrap: wrap;
          li {
            p {
              margin-right: 5px;
            }
          }
          &.footer-between {
            justify-content: unset;
            ul {
              display: flex;
              flex-wrap: wrap;
              & + ul {
                margin-left: 0px;
              }
            }
          }
          li + li {
            margin-left: 0px;
          }
          li {
            margin-top: 5px;
          }
          &:first-child {
          }
        }
        .logo-area {
          margin-right: 5px;
        }
      }
    }
    li {
      position: relative;
    }
    a {
      transition: 0.3s;
      display: flex;
      path {
        transition: 0.3s;
      }
      &:hover {
        path {
          transition: 0.1s;
        }
        g {
          path {
            fill: #3e4149;
          }
        }
        path {
          fill: #fff;
        }
        transition: 0.1s;
        color: #fff;
      }
    }
  }
`;
const Footer = ({ t, i18n }: any) => {
  return (
    <FooterStyle className="no-select">
      <div className="footer-box">
        <div className="footer-left">
          <div className="footer-contents footer-between">
            <ul>
              {i18n.language === "ko" &&
                navList.div1.map((res, idx) => {
                  return (
                    <li key={idx}>
                      <Link to={res.to}>
                        <p>{t(res.name)}</p>
                      </Link>
                    </li>
                  );
                })}
            </ul>
            <ul>
              {navList.sns.map((res, idx) => {
                return (
                  <li className="logo-area" key={idx}>
                    <Link target="_blank" to={res.to}>
                      {res.logo}
                    </Link>
                  </li>
                );
              })}
              <li className="footer-select">
                <select
                  defaultValue=""
                  onChange={(e) => window.open(e.target.value)}
                >
                  <option value="" disabled>
                    SCGS FAMILY
                  </option>
                  <option value={"https://kaiper.io"}>KAIPER</option>
                  <option value={"https://www.scgs.co.th"}>
                    SCGS THAILAND
                  </option>
                  <option value={"https://scgsseagate.co.kr"}>Seagate</option>
                  {/* <option value={"http://salesforce.scgs.co.kr"}>SFDC</option> */}
                  <option value={"https://okdell.com"}>OKDELL</option>
                </select>
              </li>
            </ul>
          </div>
          <div className="footer-contents footer-between">
            <ul>
              {navList.div2.map((res, idx) => {
                return (
                  <li key={idx}>
                    <p>
                      {t(res.key)} : {t(res.value)}
                      {idx === 1 && <a href="mailto:admin@scgs.co.kr" />}
                      {idx === 2 && <a href="tel:02-1811-7247" />}
                    </p>
                  </li>
                );
              })}
            </ul>
            <ul></ul>
          </div>
          <div className="footer-contents">
            {navList.div3.map((res, idx) => {
              return (
                <li key={idx}>
                  <p>
                    {t(res.key)} {t(res.value)}
                  </p>
                </li>
              );
            })}
          </div>
        </div>
      </div>
    </FooterStyle>
  );
};

export default Footer;
